/**
 * ページングのデフォルトのサイズ
 */
export const PIT_PORT_PAGINATION_DEFAULT_SIZE = 25;

/**
 * ページングのデフォルトのインデックス
 */
export const PIT_PORT_PAGINATION_DEFAULT_INDEX = 1;

/**
 * ページングのデフォルトの総ページ数
 */
export const PIT_PORT_PAGINATION_DEFAULT_TOTAL_PAGES = 1;
